module.exports = __webpack_public_path__ + "images/10.png";